import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login      from './pages/Login';
import Layout     from './components/Layout';
import Dashboard  from './pages/Dashboard';
import Produtos   from './pages/Produtos';
import Clientes   from './pages/Clientes';
import Vendas     from './pages/Vendas';
import Financeiro from './pages/Financeiro';
import Compras    from './pages/Compras';
import Empresas    from './pages/Empresas';
import Usuarios    from './pages/Usuarios';
import LogsAcesso  from './pages/LogsAcesso';

function Privado({ children }) {
  const { autenticado, carregando } = useAuth();
  if (carregando) return null;
  return autenticado ? children : <Navigate to="/" replace />;
}

function SomenteAdmin({ children }) {
  const { autenticado, carregando, isAdmin } = useAuth();
  if (carregando) return null;
  if (!autenticado) return <Navigate to="/" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/*" element={
            <Privado>
              <Layout>
                <Routes>
                  <Route path="/dashboard"      element={<Dashboard />} />
                  <Route path="/produtos"        element={<Produtos />} />
                  <Route path="/clientes"        element={<Clientes />} />
                  <Route path="/vendas"          element={<Vendas />} />
                  <Route path="/financeiro"      element={<Financeiro />} />
                  <Route path="/compras"         element={<Compras />} />
                  <Route path="/admin/empresas"  element={<SomenteAdmin><Empresas /></SomenteAdmin>} />
                  <Route path="/admin/usuarios"  element={<SomenteAdmin><Usuarios /></SomenteAdmin>} />
                  <Route path="/admin/logs"      element={<SomenteAdmin><LogsAcesso /></SomenteAdmin>} />
                  <Route path="*"               element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </Privado>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
